import {RefObject, useCallback} from 'react';
import {useInfiniteScroll} from 'core/hooks/useInfiniteScroll';
import {IGetReviewsRequest, TGetReviewsTransformedResponse} from 'modules/product-card/models/Review';

interface IParams {
    reviewsBoundRef: RefObject<HTMLElement>;
    data: TGetReviewsTransformedResponse | undefined;
    isLoading: boolean;
    getReviews: (newParams: Partial<IGetReviewsRequest>) => void;
}

export const useReviewsScroll = ({reviewsBoundRef, data, isLoading, getReviews}: IParams) => {
    const onScroll = useCallback(() => {
        const pageSize = data?.pagination?.pageSize || 0;
        const pageNumber = data?.pagination?.pageNumber || 0;
        const totalCount = data?.pagination?.totalCount || 0;

        if (pageSize * pageNumber < totalCount && getReviews) {
            getReviews({pageNumber: pageNumber + 1});
        }
    }, [data, getReviews]);

    useInfiniteScroll({
        active: !isLoading,
        boundaryRef: reviewsBoundRef,
        onScrollToBoundary: onScroll,
    });
};
